'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = actionCreatorFactory;

function actionCreatorFactory(config, type) {
  var normalizedConfig = config !== null && (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : {};
  var configPayload = config.payload,
      configMeta = config.meta,
      configError = config.error;

  function actionCreator(payload, meta, error) {
    var action = {
      type: type
    };

    var finalMeta = _extends({}, configMeta, meta);

    if (Object.keys(finalMeta).length) {
      action.meta = finalMeta;
    }

    var finalPayload = payload !== undefined ? payload : configPayload;

    if (finalPayload !== undefined) {
      action.payload = finalPayload;
    }

    var finalError = error !== undefined ? error : configError;

    if (finalError !== undefined) {
      action.error = finalError;
    }

    return action;
  }

  Object.assign(actionCreator, normalizedConfig);
  return actionCreator;
}